import React from 'react';
import LogoTwo from './LogoTwo';

/**
 * This header rendered an empty nav — it imported Nav, MobileMenu and
 * LogoTwo but never placed any of them in the markup, so the live site had
 * no navigation or logo at all. Nav.js is the original template's full
 * mega-menu (Home One/Two/Three, Arbor Management, Garden Management, blog,
 * portfolio...) and is left exactly as unused as it already was — those
 * pages aren't reachable from anywhere real, so linking to them here would
 * just resurrect dead pages. This nav is the four quick links AgricHub
 * actually needs: the store, becoming a vendor, the farmer/vendor portal,
 * and the app.
 */
export default class HeaderTwo extends React.Component {
    render(){
        return (
            <>
                <header className="main-header main-header-one main-header-two">
                    <div className="main-header-one__bottom">
                        <div className="main-header-one__bottom-inner">
                            <nav className="main-menu main-menu-one">
                                <div className="main-menu__wrapper clearfix">
                                    <div className="auto-container">
                                        <div className="main-menu__wrapper-inner">
                                            <div className="main-header-one__bottom-left">
                                                <LogoTwo />
                                            </div>

                                            <div className="main-header-one__bottom-middle">
                                                <ul className="main-header-one__top-menu-list">
                                                    <li><a href="https://store.agrichub.co.za/become-a-vendor">Become A Vendor</a></li>
                                                    <li><a href="https://store.agrichub.co.za/vendor/login">Farmer Portal</a></li>
                                                    <li><a href="https://play.google.com/store/apps/details?id=za.co.agrichub&hl=en_ZA">Get The App</a></li>
                                                </ul>
                                            </div>

                                            <div className="main-header-one__bottom-right">
                                                <div className="main-header-one__bottom-right-btn">
                                                    <a href="https://store.agrichub.co.za" className="thm-btn">Shop Now</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </header>
            </>
        )
    }
}
